import React, { useEffect } from "react";
import { FloatingLabelInput } from "../floatinglable/floating";
import { useDebounce } from "@/hooks/use-debounce";

type BaseSearchCriteria = {
  limit: number;
  search_key?: string;
  offset: number;
  sort_key: string;
  sort_order: string;
  [key: string]: any;
};

type TableSearchFilterProps<T extends BaseSearchCriteria = BaseSearchCriteria> = {
  setSearchCriteria: React.Dispatch<React.SetStateAction<T>>;
  placeHolder?: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  inputValue: string;
  disable?: boolean;
  initialValue?: Partial<T>;
};

const TableSearchFilter = <T extends BaseSearchCriteria = BaseSearchCriteria>({
  setSearchCriteria,
  placeHolder = "Search by Name",
  inputValue = "",
  setInputValue,
  initialValue,
  disable = false,
}: TableSearchFilterProps<T>) => {
  const debouncedInputValue = useDebounce<string>(inputValue, 500);
  useEffect(() => {
    setSearchCriteria((prev) => {
      const newCriteria = { ...prev } as T;

      if (debouncedInputValue.trim() !== "") {
        newCriteria.search_key = debouncedInputValue.trim();
        newCriteria.offset = 0;
        newCriteria.sort_key = initialValue?.sort_key ?? prev.sort_key ?? "id";
        newCriteria.sort_order = initialValue?.sort_order ?? prev.sort_order ?? "desc";
      } else {
        delete newCriteria.search_key;
      }

      return newCriteria;
    });
  }, [debouncedInputValue, setSearchCriteria, initialValue]);

  const handleInputChange: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event) => {
    setInputValue(event.target.value);
  };

  const preventLeadingSpace: React.KeyboardEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event) => {
    if (event.key === " " && !(event.target as HTMLInputElement).value) {
      event.preventDefault();
    }
  };
  return (
    <div className="flex items-center flex-1 space-x-2 mb-2 lg:mb-0">
      <div className="flex items-center relative w-full lg:w-auto">
        {/* search icon */}
        <i className="fa-solid fa-magnifying-glass size-4 text-gray-400 absolute left-1 z-10 ml-2"></i>
        <FloatingLabelInput
          id="search"
          placeholder={placeHolder}
          value={inputValue}
          disabled={disable}
          onChange={handleInputChange}
          onKeyDown={preventLeadingSpace}
          className=" w-80 lg:w-64 pl-8 text-sm placeholder:text-sm text-gray-400 h-8"
        />
      </div>
    </div>
  );
};

export default TableSearchFilter;
